import React, { useMemo, useEffect, useState, forwardRef, useImperativeHandle } from 'react';

// BOOTSTRAP
import Row from '~/components/Bootstrap/Row';
import { ColSm12, ColSm2, ColSm3, ColSm4, ColSm6, ColSm8 } from '~/components/Bootstrap/Col';
import H3 from '~/components/Bootstrap/H3';
import Label from '~/components/Bootstrap/Label';

// COMPONENTES GERAIS
import Modal, { ModalHeader } from "~/components/Modal";

// STYLED COMPONENTS
import { Main, Content, Footer } from "./styles";

// INPUTS
import InputNormal from '~/components/Inputs/Normal/Normal';
import TextareaNormal from '~/components/Textareas/Normal';
import SelectNormal from '~/components/Selects/Normal/Normal';

// BUTONS
import ButtonPrimary from '~/components/Buttons/Normal/Primary';
import ButtonSecondary from '~/components/Buttons/Normal/Secondary';
import ButtonDanger from '~/components/Buttons/Normal/Danger';

// UTILS
import numeral from '~/utils/numeral';
import Utils from '~/utils';
import NotificacaoUtil from '~/utils/notificacao';

// SERVICES
import WebsocketService, { WS_EVENT_UPDATED } from '~/services/websockets';
import APIRequests from "~/services/requests/painel";


const ModalLiberateSetupPDVNFCe = forwardRef(
    ({
        onConfirm = () => { }
    }, ref) => {

        const [isVisible, setVisible] = useState(false);

        const [UUID, setUUID] = useState('');
        const [Serial, setSerial] = useState('');
        const [Emitente, setEmitente] = useState('');

        const onRequestConfirm = async () => {

            try {

                const retorno_api = await APIRequests.pdv_nfce.liberar_instalacao(UUID, {});

                if (retorno_api?.id) {

                    NotificacaoUtil.success({
                        msg: `PDV NFCe liberado com sucesso`,
                    });

                    // fecha o modal
                    onRequestClose();

                    // dispara a função externa
                    onConfirm();

                    /**
                     * Dispara a notificação para o PDV.
                     */
                    WebsocketService.pdvs_nfce.emit(WS_EVENT_UPDATED, {
                        serial: Serial,
                    });

                } else {
                    NotificacaoUtil.error({
                        msg: `Erro ao liberar o PDV NFCe`,
                        timeout: 3500,
                    });
                }

            } catch (error) {
                NotificacaoUtil.error({
                    msg: error.message,
                    timeout: 3500,
                });
            }

        }

        const onRequestOpen = async (uuid = false) => {

            let visible = true;

            const dados = await APIRequests.pdv_nfce.obter(uuid);

            if (dados.uuid) {

                setUUID(dados.uuid);
                setSerial(dados.serial);
                setEmitente(dados.emitente);

            } else {
                visible = false;
                new Noty({
                    type: 'error',
                    timeout: 2500,
                    text: 'Falha ao carregar os dados do PDV NFCe.'
                }).show();
            }

            if (visible) {
                setVisible(visible);
            }

        }

        const onRequestClose = () => {
            setVisible(false);

            // reseta o estado
            setUUID('');
            setSerial('');
            setEmitente('');
        }

        /**
         * Passa a função de buscar para fora do input via ref.
         */
        useImperativeHandle(ref, () => (
            {
                open: onRequestOpen,
                close: onRequestClose
            }
        ));

        return (
            <Modal
                isVisible={isVisible}
                setVisible={onRequestClose}
                closeButtonVisible={false}
                closeOnClickOutside={false}
                width={420}
                height={305}
            >
                <Main>
                    <ModalHeader>
                        Liberar PDV NFCe para instalação
                    </ModalHeader>

                    <Content>

                        <Row>
                            <ColSm6>
                                <Label>Serial</Label>
                                <InputNormal
                                    disabled
                                    value={Serial}
                                />
                            </ColSm6>
                            <ColSm6>
                                <Label>Emitente</Label>
                                <InputNormal
                                    disabled
                                    value={Emitente}
                                />
                            </ColSm6>
                        </Row>

                        <H3 style={{ color: '#b75555' }}>Tem certeza que deseja liberar para instalação?</H3>

                        <Footer>

                            <ButtonSecondary onClick={onRequestClose}>
                                Fechar
                            </ButtonSecondary>

                            <ButtonDanger onClick={onRequestConfirm}>
                                Liberar
                            </ButtonDanger>

                        </Footer>

                    </Content>
                </Main>
            </Modal>
        )

    }
);

export default ModalLiberateSetupPDVNFCe;